/**
 * permalink.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { SearchService } from "app/search/search.service";

/**
 * {@link PermalinkComponent}
 */
@Component({
  template: `<!-- permalink component -->`
})
export class PermalinkComponent implements OnInit
{
  private route : ActivatedRoute;
  private search : SearchService;

  /**
   * Construct a new {@link PermalinkComponent}.
   *
   */
  public constructor (route : ActivatedRoute, search : SearchService)
  {
    this.route = route;
    this.search = search;
  }

  public ngOnInit () : void
  {
    const caseId : string = this.route.snapshot.params.case_id;
    if (!caseId)
    {
      console.error(
        "Cannot load empty case ID:", caseId, this.route.snapshot.params);
      return;
    }

    this.search.vendorABC_navigateToHCBRecord(caseId);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/intake-form/permalink.component.ts